import {
  FilterType,
  TrainingsTrainingMembershipStatusEnum,
  buildMyTrainingsDatatableFilter,
  useMyTrainingsDatatable,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

import { TrainingMembershipStatusTag } from 'modules/trainings/components/Shared/TrainingMembershipStatusTag'

type FilterOption = {
  label: string
  value: TrainingsTrainingMembershipStatusEnum
  component: JSX.Element
}

export const statusFilter = (source: ReturnType<typeof useMyTrainingsDatatable>) => {
  const options: FilterOption[] = [
    {
      label: i18n.t('trainings.my_training.all_courses_table.not_started'),
      value: 'notstarted',
      component: <TrainingMembershipStatusTag status="notstarted" />,
    },
    {
      label: i18n.t('trainings.my_training.all_courses_table.completed'),
      value: 'completed',
      component: <TrainingMembershipStatusTag status="completed" />,
    },
    {
      label: i18n.t('trainings.my_training.all_courses_table.started'),
      value: 'started',
      component: <TrainingMembershipStatusTag status="started" />,
    },
    {
      label: i18n.t('trainings.my_training.all_courses_table.partially_completed'),
      value: 'partiallycompleted',
      component: <TrainingMembershipStatusTag status="partiallycompleted" />,
    },
    {
      label: i18n.t('trainings.my_training.all_courses_table.absent'),
      value: 'missing',
      component: <TrainingMembershipStatusTag status="missing" />,
    },
  ]
  return buildMyTrainingsDatatableFilter(source, {
    identifier: 'status_filter',
    title: i18n.t('trainings.my_trainings_revamp.overview.courses_datatable.status_column'),
    path: 'trainingAttendanceStatus',
    default: true,
    type: FilterType.String,
    categories: [
      {
        kind: 'SingleChoice',
        operation: 'eq',
        options,
      },
    ],
  })
}
